import styled from "styled-components";

export const MyDrivePageContentLayout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  height: 100%;
  overflow-y: auto;
`;

export const MainContentsList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-bottom: 2px solid ${(props) => props.theme.colors.mainBg};
`;

export const DetailRouteBox = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export const DetailRoute = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  span {
    color: ${(props) => props.theme.colors.primary};
    font-size: 1.4rem;
    font-weight: 600;
  }
`;

export const MainContentsItem = styled.div`
  display: flex;
  padding: 20px;
  background: ${(props) => props.theme.colors.white};
  flex-direction: column;
  gap: 20px;
`;

export const NodataItemBox = styled.div`
  display: flex;
  color: ${(props) => props.theme.colors.placeholderTxt};
  align-items: center;
  justify-content: center;
  flex-direction: column;

  p {
    display: flex;
    height: 120px;
    font-size: 1.4rem;
    align-items: center;
    justify-content: center;
  }
`;

export const DataItemBox = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const DataHeadBox = styled.div`
  display: flex;
  width: 100%;
  height: 30px;
  align-items: center;
  justify-content: space-between;

  & > div {
    display: flex;
    padding-left: 5px;
    font-size: 1.6rem;
    font-weight: 600;
    color: ${(props) => props.theme.colors.primary};
    align-items: center;
    gap: 6px;
  }
`;

export const DataListBox = styled.div`
  display: flex;
  margin-top: 6px;
  padding: 0 10px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const DataRouteBox = styled.div`
  display: grid;
  margin: 14px 0;
  padding: 15px 0;
  background: ${(props) => props.theme.colors.mainBg};
  border-radius: 10px;
  grid-template-columns: 1fr 10px 1fr 10px 1fr;
  align-items: center;
  justify-content: center;
`;

export const DataListItemBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`;

export const DataListItemText = styled.p`
  font-size: 1.4rem;
  font-weight: 500;
  color: ${(props) => props.theme.colors.contentLabelTxt};

  &.fontBlack {
    color: ${(props) => props.theme.colors.black};
    font-size: 1.6rem;
    font-weight: 600;
  }
`;

export const StatusToken = styled.div<{ color: any }>`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: ${(props) =>
    props.color === "COMPLETED_REVIEW"
      ? props.theme.colors.COMPLETED_REVIEW
      : props.color === "TAX_INVOICE_REQUEST_COMPLETED"
      ? props.theme.colors.TAX_INVOICE_REQUEST_COMPLETED
      : props.color === "TAX_INVOICE_ERROR"
      ? props.theme.colors.TAX_INVOICE_ERROR
      : props.color === "TAX_INVOICE_PUBLISHED_COMPLETED"
      ? props.theme.colors.TAX_INVOICE_PUBLISHED_COMPLETED
      : props.color === "COMPLETED"
      ? props.theme.colors.COMPLETED
      : props.theme.colors.DEFAULT_STATUS};
  border-radius: 8px;

  span {
    color: ${(props) => props.theme.colors.white};
    font-size: 1.4rem;
    font-weight: 400;
  }
`;
